export interface Listener<T> {
    (event: T, arg?: any): any;
}

export interface Disposable {
    dispose(): void;
}

export class TypedEvent<T> {

    private listeners: Listener<T>[] = [];
    private listenersOncer: Listener<T>[] = [];

    on = (listener: Listener<T>): Disposable => {
        this.listeners.push(listener);
        return {
            dispose: () => this.off(listener)
        };
    };

    once = (listener: Listener<T>): void => {
        this.listenersOncer.push(listener);
    };

    off = (listener: Listener<T>) => {
        let callbackIndex = this.listeners.indexOf(listener);
        if (callbackIndex > -1) this.listeners.splice(callbackIndex, 1);
    };

    emit = <U>(event: T, arg?: U) => {
        this.listeners.forEach((listener) => listener(event, arg));

        this.listenersOncer.forEach((listener) => listener(event, arg));
        this.listenersOncer = [];
    };

    pipe = (te: TypedEvent<T>): Disposable => {
        return this.on((e) => te.emit(e));
    };
}

/*
* this.emitter = new TypedEvent<string>();
* this.emitter.on((event,arg) => {
*   do something
* })
* this.emitter.emit("SomeEventString",arg)
* */